<mat-card>
  <h1>SPYC West Wind Race Headings</h1>
  <p>WARNING! AI generated and may be inaccurate.</p>
  <table border="1" cellpadding="6" cellspacing="0" style="border-collapse: collapse; font-family: sans-serif; width: 100%; text-align: left;">
    <thead>
      <tr>
        <th>Race</th>
        <th>Course Leg</th>
        <th>Magnetic Heading</th>
        <th>Rounding Direction</th>
      </tr>
    </thead>
    <tbody>
      <!-- Race 2 -->
      <tr>
        <td rowspan="2" style="font-weight: bold; vertical-align: top;">Race 2</td>
        <td>W &rarr; 2</td>
        <td>026.7&deg;M</td>
        <td>Keep 2 to <strong>Starboard</strong></td>
      </tr>
      <tr>
        <td>2 &rarr; E2</td>
        <td>211.2&deg;M</td>
        <td>Keep E2 to <strong>Port</strong></td>
      </tr>
      <!-- Race 4 -->
      <tr style="border-top: 2px solid #ddd;">
        <td rowspan="2" style="font-weight: bold; vertical-align: top;">Race 4</td>
        <td>W &rarr; 4</td>
        <td>075.8&deg;M</td>
        <td>Keep 4 to <strong>Starboard</strong></td>
      </tr>
      <tr>
        <td>4 &rarr; E1</td>
        <td>262.8&deg;M</td>
        <td>Keep E1 to <strong>Starboard</strong></td>
      </tr>
      <!-- Race 6 -->
      <tr style="border-top: 2px solid #ddd;">
        <td rowspan="2" style="font-weight: bold; vertical-align: top;">Race 6</td>
        <td>W &rarr; 6</td>
        <td>106.6&deg;M</td>
        <td>Keep 6 to <strong>Starboard</strong></td>
      </tr>
      <tr>
        <td>6 &rarr; E1</td>
        <td>290.5&deg;M</td>
        <td>Keep E1 to <strong>Starboard</strong></td>
      </tr>
      <!-- Race 24 -->
      <tr style="border-top: 2px solid #ddd;">
        <td rowspan="3" style="font-weight: bold; vertical-align: top;">Race 24</td>
        <td>W &rarr; 2</td>
        <td>026.7&deg;M</td>
        <td>Keep 2 to <strong>Starboard</strong></td>
      </tr>
      <tr>
        <td>2 &rarr; 4</td>
        <td>145.9&deg;M</td>
        <td>Keep 4 to <strong>Starboard</strong></td>
      </tr>
      <tr>
        <td>4 &rarr; E1</td>
        <td>262.8&deg;M</td>
        <td>Keep E1 to <strong>Starboard</strong></td>
      </tr>
      <!-- Race 42 -->
      <tr style="border-top: 2px solid #ddd;">
        <td rowspan="3" style="font-weight: bold; vertical-align: top;">Race 42</td>
        <td>W &rarr; 4</td>
        <td>075.8&deg;M</td>
        <td>Keep 4 to <strong>Port</strong></td>
      </tr>
      <tr>
        <td>4 &rarr; 2</td>
        <td>325.9&deg;M</td>
        <td>Keep 2 to <strong>Port</strong></td>
      </tr>
      <tr>
        <td>2 &rarr; E2</td>
        <td>211.2&deg;M</td>
        <td>Keep E2 to <strong>Port</strong></td>
      </tr>
      <!-- Race 46 -->
      <tr style="border-top: 2px solid #ddd;">
        <td rowspan="3" style="font-weight: bold; vertical-align: top;">Race 46</td>
        <td>W &rarr; 4</td>
        <td>075.8&deg;M</td>
        <td>Keep 4 to <strong>Starboard</strong></td>
      </tr>
      <tr>
        <td>4 &rarr; 6</td>
        <td>145.3&deg;M</td>
        <td>Keep 6 to <strong>Starboard</strong></td>
      </tr>
      <tr>
        <td>6 &rarr; E1</td>
        <td>290.5&deg;M</td>
        <td>Keep E1 to <strong>Starboard</strong></td>
      </tr>
      <!-- Race 64 -->
      <tr style="border-top: 2px solid #ddd;">
        <td rowspan="3" style="font-weight: bold; vertical-align: top;">Race 64</td>
        <td>W &rarr; 6</td>
        <td>106.6&deg;M</td>
        <td>Keep 6 to <strong>Port</strong></td>
      </tr>
      <tr>
        <td>6 &rarr; 4</td>
        <td>325.3&deg;M</td>
        <td>Keep 4 to <strong>Port</strong></td>
      </tr>
      <tr>
        <td>4 &rarr; E1</td>
        <td>262.8&deg;M</td>
        <td>Keep E1 to <strong>Starboard</strong></td>
      </tr>
      <!-- Race 4124 -->
      <tr style="border-top: 2px solid #ddd;">
        <td rowspan="5" style="font-weight: bold; vertical-align: top;">Race 4124</td>
        <td>W &rarr; 4</td>
        <td>075.8&deg;M</td>
        <td>Keep 4 to <strong>Port</strong></td>
      </tr>
      <tr>
        <td>4 &rarr; 1</td>
        <td>325.9&deg;M</td>
        <td>Keep 1 to <strong>Port</strong></td>
      </tr>
      <tr>
        <td>1 &rarr; 2</td>
        <td>347.0&deg;M</td>
        <td>Keep 2 to <strong>Port</strong></td>
      </tr>
      <tr>
        <td>2 &rarr; 4</td>
        <td>145.9&deg;M</td>
        <td>Keep 4 to <strong>Starboard</strong></td>
      </tr>
      <tr>
        <td>4 &rarr; E1</td>
        <td>262.8&deg;M</td>
        <td>Keep E1 to <strong>Starboard</strong></td>
      </tr>
    </tbody>
  </table>
</mat-card>
